export const formatCurrency = (val, currency, options) => {
    let formattedValue;
    let abbreviation = null;
    const abbreviations = [
        { floor: 1E3, suffix: 'K' },
        { floor: 1E6, suffix: 'M' },
        { floor: 1E9, suffix: 'B' }
    ];
    if (options && options.abbreviate) {
        for (let i = abbreviations.length - 1; i >= 0; i--) {
            if (val >= abbreviations[i].floor) {
                abbreviation = abbreviations[i];
                break;
            }
        }
    }
    if (abbreviation) {
        val /= abbreviation.floor;
    }
    const fractionalDigits = options ?
        options.fractionalDigits :
        Math.abs(val) < 100 ? 2 : 0;
    const intl = window.Intl;
    if (intl) {
        const formatProps = {
            style: 'currency',
            currency: (currency && currency.length >= 3) ? currency.slice(0, 3) : 'USD',
            useGrouping: options ? options.includeThousandsSeparator : true,
            maximumFractionDigits: fractionalDigits,
            minimumFractionDigits: fractionalDigits,
            minimumSignificantDigits: val === 0 ? fractionalDigits + 1 : undefined
        };
        const formatter = new intl.NumberFormat('en-US', formatProps);
        formattedValue = formatter.format(val);
    }
    else {
        formattedValue = val.toFixed(fractionalDigits);
    }
    if (options && options.showDecimalZeros === false) {
        const formattedValueParts = formattedValue.split('.');
        if (formattedValueParts.length === 2) {
            let decimalPart = formattedValueParts[1];
            const initLen = decimalPart.length;
            for (let i = initLen - 1; i >= 0; i--) {
                if (decimalPart[i] !== '0') {
                    break;
                }
                decimalPart = decimalPart.slice(0, i);
            }
            formattedValue = decimalPart.length > 0 ?
                `${formattedValueParts[0]}.${decimalPart}` :
                formattedValueParts[0];
        }
    }
    if (abbreviation) {
        formattedValue += abbreviation.suffix;
    }
    return formattedValue;
};
